import { render, staticRenderFns } from "./DayOffRequests.vue?vue&type=template&id=eb64fd10&scoped=true"
import script from "./DayOffRequests.vue?vue&type=script&lang=js"
export * from "./DayOffRequests.vue?vue&type=script&lang=js"
import style0 from "../../../../assets/css/layout/Request.css?vue&type=style&index=0&id=eb64fd10&prod&scoped=true&lang=css&external"
import style1 from "./DayOffRequests.vue?vue&type=style&index=1&id=eb64fd10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb64fd10",
  null
  
)

export default component.exports